import Badge from '@atlaskit/badge';
import StarIconFilled from '@atlaskit/icon/glyph/star-filled';
import { LinkUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { shortFormat } from '../utils/Numeral';
import { NUMERIC_RATING_TESTID, STAR_RATINGS_TESTID, TOTAL_STARS as maxNumericRating } from './Ratings.constants';
import { AverageNumericRating, AverageRating, NoReviewText, NumericRatingContainer, RatingContainer, RatingsCount, StarIconContainer } from './Ratings.styles';
import { getRoundedRating, getStarVariations } from './Ratings.utils';
import { StarGradients } from './StarGradients';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Ratings = props => {
  const {
    onClick,
    ratings,
    showRatingCount = true,
    showNumericRating = true,
    numericRatingStyles
  } = props;
  const getStars = clickable => getStarVariations(ratings).map((variation, index) => /*#__PURE__*/_jsx(StarIconContainer, {
    clickable: clickable,
    variation: variation,
    "data-testid": "star-rating-".concat(variation),
    children: /*#__PURE__*/_jsx(StarIconFilled, {
      label: ""
    })
  }, index));
  const onRatingsClick = e => {
    if (onClick) {
      LinkUtils.maybeOpenInNewTab(e, () => {
        e.stopPropagation();
        onClick();
      });
    }
  };
  const clickable = !!onClick;
  const stars = getStars(clickable);
  const avgStars = getRoundedRating(ratings.avgStars);
  return /*#__PURE__*/_jsxs(RatingContainer, {
    onClick: onRatingsClick,
    clickable: clickable,
    "aria-label": "Rating of ".concat(avgStars, " out of ").concat(maxNumericRating, " stars based on ").concat(ratings.numRatings, " reviews"),
    children: [!!ratings.numRatings && showNumericRating && /*#__PURE__*/_jsxs(NumericRatingContainer, {
      "data-testid": NUMERIC_RATING_TESTID,
      overrideStyles: numericRatingStyles,
      children: [/*#__PURE__*/_jsx(AverageNumericRating, {
        overrideStyles: numericRatingStyles,
        children: avgStars
      }), /*#__PURE__*/_jsx("span", {
        children: "/"
      }), /*#__PURE__*/_jsx("span", {
        children: maxNumericRating
      })]
    }), /*#__PURE__*/_jsx(StarGradients, {}), /*#__PURE__*/_jsx(AverageRating, {
      "data-testid": STAR_RATINGS_TESTID,
      children: stars
    }), !ratings.numRatings && /*#__PURE__*/_jsx(NoReviewText, {
      children: "No reviews yet"
    }), !!ratings.numRatings && showRatingCount && /*#__PURE__*/_jsx(RatingsCount, {
      children: /*#__PURE__*/_jsx(Badge, {
        children: "".concat(shortFormat(ratings.numRatings))
      })
    })]
  });
};
export default Ratings;